import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Confirmar", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_5 = {
  div: "",
  class: "ss-tela-conteudo",
  style: {"height":"auto"}
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "ss-card ss-card-space" }
const _hoisted_8 = { class: "ant-row" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { style: {"text-align":"center","font-size":"24px"} }, "Adicionar Linha", -1)
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "ant-row" }
const _hoisted_13 = {
  key: 0,
  class: "ss-card ss-card-space"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_apresentar_linha_colunas = _resolveComponent("apresentar-linha-colunas")!
  const _component_card = _resolveComponent("card")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_apresentar_miniatura_campo_personalizado = _resolveComponent("apresentar-miniatura-campo-personalizado")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_nova_linha_modal = _resolveComponent("nova-linha-modal")!
  const _component_selecao_campo_personalizado_modal = _resolveComponent("selecao-campo-personalizado-modal")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_campo_personalizado_modal = _resolveComponent("campo-personalizado-modal")!

  return (_openBlock(), _createElementBlock("div", {
    key: _ctx.props.grupo.codigo
  }, [
    _createVNode(_component_a_modal, {
      keyboard: false,
      visible: _ctx.modalBase.computedVisivel,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
      style: {"width":"800px"}
    }, {
      title: _withCtx(() => [
        _createTextVNode("Grupo de Campos")
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.confirmar && _ctx.confirmar(...args)))
          }, _hoisted_2)
        ])
      ]),
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          active: "",
          loading: _ctx.telaBase.carregando,
          paragraph: { rows: 2 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, { layout: "vertical" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_a_form_item, {
                      label: "Identificador",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "100",
                          class: "ant-input",
                          disabled: "true",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.props.grupo.identificador) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.props.grupo.identificador]
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createVNode(_component_card, { titulo: "Layout" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.linhas, (linha, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "ss-card ss-card-space",
                          key: index
                        }, [
                          _createVNode(_component_a_form_item, {
                            class: "ss-margin-campos",
                            label: 'Linha ' + linha.ordem
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                title: "Remover linha",
                                class: "excluir ss-apresentar-superior-direito",
                                onClick: ($event: any) => (_ctx.removerLinha(index))
                              }, [
                                _createVNode(_component_icone, { nome: "excluir" })
                              ], 8, _hoisted_6),
                              _createVNode(_component_apresentar_linha_colunas, {
                                linha: _ctx.state.linhas[index],
                                "onUpdate:linha": ($event: any) => ((_ctx.state.linhas[index]) = $event),
                                campos: _ctx.state.campos,
                                "onUpdate:campos": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.campos) = $event)),
                                onSelecionarCampo: _ctx.selecionarCampo,
                                onEditarCampo: _ctx.editarCampo,
                                onRemoverCampo: _ctx.removerCampo
                              }, null, 8, ["linha", "onUpdate:linha", "campos", "onSelecionarCampo", "onEditarCampo", "onRemoverCampo"])
                            ]),
                            _: 2
                          }, 1032, ["label"])
                        ]))
                      }), 128)),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "ant-btn ant-btn-block",
                              style: {"min-height":"45px"},
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.adicionarLinha()))
                            }, [
                              _createVNode(_component_icone, {
                                style: {"font-size":"20px","margin-right":"10px","margin-top":"7px"},
                                nome: "novo"
                              }),
                              _hoisted_10
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_card, { titulo: "Campos Adicionados" }, {
                  default: _withCtx(() => [
                    (_ctx.contarOrfaos() === 0)
                      ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                          key: 0,
                          mensagem: "Nenhum campo não alocado"
                        }))
                      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.campos, (campo, index) => {
                              return (_openBlock(), _createElementBlock("div", { key: index }, [
                                (_ctx.obterColuna(campo) === undefined)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                      _createVNode(_component_apresentar_miniatura_campo_personalizado, {
                                        campo: _ctx.state.campos[index],
                                        "onUpdate:campo": ($event: any) => ((_ctx.state.campos[index]) = $event),
                                        onClickCampo: ($event: any) => (_ctx.editarCampo(_ctx.state.campos[index])),
                                        onRemoverCampo: ($event: any) => (_ctx.removerCampo(_ctx.state.campos[index]))
                                      }, null, 8, ["campo", "onUpdate:campo", "onClickCampo", "onRemoverCampo"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ])
                        ]))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_nova_linha_modal, {
      visivel: _ctx.state.exibirModalLinha,
      "onUpdate:visivel": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.exibirModalLinha) = $event)),
      onConfirmacao: _ctx.criarLinha
    }, null, 8, ["visivel", "onConfirmacao"]),
    _createVNode(_component_selecao_campo_personalizado_modal, {
      visivel: _ctx.state.exibirModalSelecaoCampo,
      "onUpdate:visivel": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.exibirModalSelecaoCampo) = $event)),
      campos: _ctx.state.camposOrfaos,
      onConfirmacao: _ctx.definirCampoSelecionado,
      onCriarCampo: _ctx.criarCampo
    }, null, 8, ["visivel", "campos", "onConfirmacao", "onCriarCampo"]),
    _createVNode(_component_requisicao_modal, {
      visivel: _ctx.modalBase.exibirRequisicaoModal,
      "onUpdate:visivel": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
      retornoRequisicao: _ctx.modalBase.retornoRequisicao
    }, null, 8, ["visivel", "retornoRequisicao"]),
    _createVNode(_component_campo_personalizado_modal, {
      visivel: _ctx.state.exibirModalCampo,
      "onUpdate:visivel": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.exibirModalCampo) = $event)),
      campo: _ctx.state.campoSelecionado,
      "onUpdate:campo": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.campoSelecionado) = $event)),
      onConfirmacao: _ctx.atualizarCampo
    }, null, 8, ["visivel", "campo", "onConfirmacao"])
  ]))
}